// eslint-disable-next-line import/no-extraneous-dependencies
import { Link } from 'react-router-dom';

function App() {
	// const handleDownloadClick = () => {
	// 	const url =
	// 		'https://apps.apple.com/us/app/blushed-romance-choices/id6466787923';
	// 	window.open(url, '_top', 'noopener,noreferrer');
	// };

	return (
		<div className="wrapper">
			<div className="main-wrapper">
				<img
					src="/images/background.png"
					alt="background"
					className="muse-bg"
				/>
				<div className="button-top">
					<a href="https://my-muse.onelink.me/oJny/95n86ntu">
						<img
							src="/images/get-app.png"
							// onClick={handleDownloadClick}
							className="button"
							alt="Get App"
						/>
					</a>
				</div>
				{/* <div className="download-block">
					<img
						onClick={handleDownloadClick}
						className="button-download hover"
						src="/images/app-store.png"
						alt="App Store"
					/>
					<img
						src="/images/play-store.png"
						className="button-download"
						alt="Google Play"
					/>
				</div> */}
			</div>

			<div className="policy-wrapper">
				{/* <div className="line" /> */}
				<img src="/images/footer.png" alt="footer" className="muse-footer" />
				<div className="links-wrapper">
					<Link to="/terms-of-use" style={{ textDecoration: 'none' }}>
						<div className="policy-item">Terms</div>
					</Link>
					<Link to="/privacy-policy" style={{ textDecoration: 'none' }}>
						<div className="policy-item">Privacy</div>
					</Link>
					<Link to="/subscription-terms" style={{ textDecoration: 'none' }}>
						<div className="policy-item">Subscription terms</div>
					</Link>
					<a
						href="mailto:support@muse-app.co"
						style={{ textDecoration: 'none' }}
					>
						<div className="policy-item">Contact us</div>
					</a>
				</div>
			</div>
			<div className="policy-subtitle">
				<div className="bold">Zereli Limited</div> Lykavitou, 46, Egkomi, 2401,
				Nicosia, Cyprus
			</div>
		</div>
	);
}

export default App;
